export default {
  claimRewardSelectAllCheckbox: 'layout-claim-reward-select-all-checkbox',
  claimRewardOpenModalButton: 'layout-claim-reward-open-modal-button',
  claimRewardBreakdown: 'layout-claim-reward-breakdown',
  claimExternalRewardBreakdown: 'layout-claim-external-reward-breakdown',
  claimRewardSubmitButton: 'layout-claim-reward-submit-button',
  claimRewardExternalRewards: 'layout-claim-reward-external-rewards',
};
